import {
  co2AvoidedIcon,
  consumptionIcon,
  consumptionIcon2,
  energyIcon,
  energySavingIcon,
  productIcon,
} from "assets/icons";
import { DashboardHome, homeGridImage, powerSupply } from "assets/images";
import React from "react";
import { Link } from "react-router-dom";
import { formatDecimalNumber } from "utils/commonFun";

const LifeTimeSummary = ({ dashboardData }) => {
  // console.log('dashboardData', dashboardData)
  const lifeTime = dashboardData?.lifeTime || {};
  const realTime = dashboardData?.realTime || {};

  return (
    <>
      <div className="summery_wrap">
        <div className="_card grid">
          {/* <img src={homeGridImage} alt="" className='w-100' /> */}
          {/* <img src={powerSupply} alt="" /> */}
          <img src={DashboardHome} alt="" className="w-100" />
          <div className="realtime_grid_support">
            <div className="supply_data">
              <b>{formatDecimalNumber(realTime?.gridKw)} KW</b>
              <span>Grid</span>
            </div>
            <div className="supply_data">
              <b>{formatDecimalNumber(realTime?.solarKw)} KW</b>
              <span>Solar</span>
            </div>
            <div className="supply_data">
              <b>{formatDecimalNumber(realTime?.totalConsumptionKw)} KW</b>
              <span>Load</span>
            </div>
            <div className="supply_data">
              <b>{formatDecimalNumber(realTime?.dgKw)} KW</b>
              <span>DG</span>
            </div>
          </div>
        </div>
        <div className="_card energy_details">
          <h3 className="title">Life-time Summary</h3>
          <div className="summery_card_wrap">
            <div className="summery_card">
              <img src={productIcon} alt="" />
              <div className="content">
                <span>Solar Production</span>
                <h4>{formatDecimalNumber(lifeTime?.totalSolarKwh)} kWh</h4>
              </div>
            </div>
            <div className="summery_card">
              <img src={consumptionIcon} alt="" />
              <div className="content">
                <span>Total Consumption</span>
                <h4>{formatDecimalNumber(lifeTime?.totalConsumptionKwh)} kWh</h4>
              </div>
            </div>
            <div className="summery_card">
              <img src={energySavingIcon} alt="" />
              <div className="content">
                <span>Energy Saving</span>
                <h4>₹{formatDecimalNumber(lifeTime?.energySaving)}</h4>
              </div>
            </div>
            <div className="summery_card">
              <img src={co2AvoidedIcon} alt="" />
              <div className="content">
                <span>Co2 Avoided</span>
                <h4>{formatDecimalNumber(lifeTime?.co2Avoided)} MT</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="energy_card_section">
        <div className="_card">
          <div className="summery_card">
            <img src={consumptionIcon2} alt="" />
            <div className="content">
              <img src={energyIcon} alt="" />
              <div>
                {" "}
                <span>Total Consumption</span>
                <h4>{formatDecimalNumber(realTime?.totalConsumptionKw)} kWh</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="_card">
          <div className="card_wrap">
            <Link to="/report/solar" className="energy_type_card">
              <span>Solar</span>
              <h3>{formatDecimalNumber(realTime?.solarKw)} KW</h3>
            </Link>
            <Link to="/report/dg" className="energy_type_card">
              <span>DG</span>
              <h3>{formatDecimalNumber(realTime?.dgKw)} KW</h3>
            </Link>
            <Link to="/report/grid" className="energy_type_card">
              <span>Grid</span>
              <h3>{formatDecimalNumber(realTime?.gridKw)} KW</h3>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LifeTimeSummary;
